import styled from 'styled-components'
import BlankIconButton from './BlankIconButton'

export default styled(BlankIconButton).attrs(props => ({
  type: 'circle-plus',
  color: props.theme.colors.green,
}))``
